import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { PriceInput } from "../../../../../../components/PriceInput/PriceInput";
import { putPriceListDetailBatchApi } from "./api";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";
import { Message } from "components/Message/Message";
import { InputTypes } from "types/enum";

interface Prop {
  resetForm?: boolean;
  onHide: () => void;
  PriceListObj?: any;
  mode: string;
  reload: () => void;
  selectedList?: any;
}

export const PriceListGroupEditForm = ({
  reload,
  onHide,
  selectedList,
  mode,
  PriceListObj,
}: Prop) => {
  const [resetForm, setResetForm] = useState(false);
  const [userChanges, setUserChanges] = useState<any>({});
  const [Price, setPrice] = useState<any>(false);
  const PriceTypeEnum = {
    Range: "Range",
    UnitPercent: "UnitPercent",
    DiscountPercent: "DiscountPercent",
    UnitPrice: "UnitPrice",
    AddedValueDeduction:"AddedValueDeduction"
  };
  const [priceType, setPriceType] = useState<any>(PriceTypeEnum.UnitPrice);
  const [increaseOrDecrease, setIncreaseOrDecrease] = useState(0); // 0=>increase and 1=>decrease
  const [needToCall, setNeedToCall] = useState<any>(true);
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  const submit = async (event) => {
    let flag=false
    event.preventDefault();
    // let data: any = {
    //   PriceListId: PriceListObj.Id,
    //   [Price ? "UnitPrice" : "Percent"]: Price
    //     ? +event.target.Price.value
    //     : event.target.Percent.value,
    //   DiscountPercent:
    //     event.target.DiscountPercent.value == ""
    //       ? null
    //       : +event.target.DiscountPercent.value,
    //   RoundingPlace: +event.target?.RoundingPlace?.value,
    //   MinOrderQty: PriceListObj?.HasDetailRange
    //     ? +event.target.MinOrderQty.value
    //     : 0,
    //   MaxOrderQty:
    //     PriceListObj?.HasDetailRange && event.target.MaxOrderQty?.value != ""
    //       ? event.target.MaxOrderQty.value
    //       : null,
    // };
    // if (needToCall) delete data.RoundingPlace;
    const query: any = { PriceListId: PriceListObj.Id };
    if (priceType == PriceTypeEnum.UnitPrice) {
      query.UnitPrice =
      event.target.UnitPrice.value?   increaseOrDecrease == 0
          ? event.target.UnitPrice.value.replaceAll(",", "")
          : "-" + event.target.UnitPrice.value.replaceAll(",", ""):null
      query.RoundingPlace = event.target?.RoundingPlace?.value;
    }
        else if (priceType == PriceTypeEnum.AddedValueDeduction) {  
            query.RoundingPlace = event.target?.RoundingPlace?.value;
    }
    
    else if (priceType == PriceTypeEnum.UnitPercent) {  
        query.UnitPercent =
        event.target.UnitPercent.value?   increaseOrDecrease == 0
            ? event.target.UnitPercent.value
            : "-" + event.target.UnitPercent.value:null
            query.RoundingPlace = event.target?.RoundingPlace?.value;
    } else if (priceType == PriceTypeEnum.DiscountPercent) {
      query.DiscountPercent =
      event.target.DiscountPercent.value ?  increaseOrDecrease == 0
      ? event.target.DiscountPercent.value
      : "-" + event.target.DiscountPercent.value:null
    } else {
      if(event.target.elements.MinOrderQty.value<0){
        event.target.elements.MinOrderQty.setCustomValidity(trans('Msg_ValueCannotBeZero'))
        event.target.elements.MinOrderQty.reportValidity() 
        flag=true
      }
      else if((event.target.elements.MaxOrderQty.value!='' && event.target.elements.MaxOrderQty.value!=null)&&(event.target.MaxOrderQty.value==0  || +event.target.MaxOrderQty.value< +event.target.MinOrderQty.value)){
        event.target.elements.MaxOrderQty.setCustomValidity(trans('Msg_ErrorMaxOrderLowerThanMinOrder'))
        event.target.elements.MaxOrderQty.reportValidity() 
        flag=true
      }
   
      else{
        query.MinOrderQty = event.target.MinOrderQty.value;
        query.MaxOrderQty = event.target.MaxOrderQty.value?
        event.target.MaxOrderQty.value:null;
      }
    }

    try {
      if(!flag){
        
      await putPriceListDetailBatchApi(
        !!selectedList.length ? selectedList.map((item) => item.Id) : [],
        query,
        priceType
      );
      reload();
      onHide();
      sessionStorage.setItem("changingforms", "false");
      setUserChanges({});
    }
    } catch (error) {
      sessionStorage.setItem("changingforms", "false");
      setUserChanges({});
      onHide();
    }
  };

  useEffect(() => {
    if (resetForm) {
      setUserChanges({});
    }
  }, [resetForm]);

  return (
    <>
      <>
        <form className=" " onSubmit={submit}>
          {/* {PriceListObj?.HasDetailRange && (
            <FormWithTitle title="filter">
              <div className="row ">
                <div
                  className="col-md-3 mr-2 col-sm-12"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    onChange={(e) => {
                      if (e.target.value.startsWith("-")) {
                        setUserChanges({
                          ...userChanges,
                          MinOrderQty: "0",
                        });
                      }
                    }}
                    textboxName={"MinOrderQty"}
                    textboxType="number"
                    resetForm={resetForm}
                    labelText={"MinOrderQty"}
                    mode={mode}
                    defaultValue={userChanges?.MinOrderQty ?? "0"}
                  />
                </div>
                <div
                  className="col-md-3 col-sm-12"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <Textbox
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    onChange={(e) => {
                      if (e.target.value.startsWith("-")) {
                        setUserChanges({
                          ...userChanges,
                          MaxOrderQty: "0",
                        });
                      }
                    }}
                    textboxName={"MaxOrderQty"}
                    textboxType="number"
                    resetForm={resetForm}
                    labelText={"MaxOrderQty"}
                    mode={mode}
                    defaultValue={userChanges?.MaxOrderQty ?? "0"}
                  />
                </div>
              </div>
            </FormWithTitle>
          )} */}
          <>
         <Message
              message={`${priceType==PriceTypeEnum.AddedValueDeduction ?'مقدار ارزش افزوده از قیمت واحد کسر می گردد.':priceType!=PriceTypeEnum.Range?trans("Help_ValueUnmodified"):trans('Help_MinMaxOrder').replace('\\n','<br/>')} 
              ${(  priceType==PriceTypeEnum.UnitPrice ||priceType==PriceTypeEnum.UnitPercent) ?trans("Help_ValueChange"):''} 
               ${priceType==PriceTypeEnum.UnitPrice?trans("Help_FinalPrice"):priceType==PriceTypeEnum.UnitPercent?trans("Help_FinalPricePercent"):priceType==PriceTypeEnum.DiscountPercent ?trans("Help_FinalDiscountPercent"):''}`}
              type={"instruction"}
            />
            <div className="card">
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-auto">
                    <CheckableButton
                      onchange={(e) =>
                        e && setPriceType(PriceTypeEnum.UnitPrice)
                      }
                      defaultChecked={priceType == PriceTypeEnum.UnitPrice}
                      labelText={"UnitPrice"}
                      inputName={"priceType"}
                      type="radio"
                    />
                  </div>

                  <div className="col-auto">
                    <CheckableButton
                      onchange={(e) =>
                        e && setPriceType(PriceTypeEnum.UnitPercent)
                      }
                      labelText={"UnitPercent"}
                      inputName={"priceType"}
                      type="radio"
                      defaultChecked={priceType == PriceTypeEnum.UnitPercent}
                    />
                  </div>
                  <div className="col-auto">
                    <CheckableButton
                      // defaultChecked={IsDefault}
                      onchange={(e) =>
                        e && setPriceType(PriceTypeEnum.DiscountPercent)
                      }
                      labelText={"DiscountPercent"}
                      inputName={"priceType"}
                      type="radio"
                      defaultChecked={
                        priceType == PriceTypeEnum.DiscountPercent
                      }
                    />
                  </div>
                  <div className="col-auto">
                    <CheckableButton
                      // defaultChecked={IsDefault}
                      onchange={(e) => e && setPriceType(PriceTypeEnum.Range)}
                      labelText={
                        trans("MinOrderQty") + " / " + trans("MaxOrderQty")
                      }
                      inputName={"priceType"}
                      type="radio"
                      defaultChecked={priceType == PriceTypeEnum.Range}
                    />
                  </div>
                        <div className="col-auto">
                    <CheckableButton
                      onchange={(e) =>
                        e && setPriceType(PriceTypeEnum.AddedValueDeduction)
                      }
                      labelText={"کسر ارزش افزوده"}
                      inputName={"priceType"}
                      type="radio"
                      defaultChecked={priceType == PriceTypeEnum.AddedValueDeduction}
                    />
                  </div>
                </div>

                {priceType == PriceTypeEnum.UnitPrice ? (
                  <div className="row">
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                             {/* <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName={"UnitPrice"}
                        textboxType="text"
                        useGroupingPrice
                        asNumber
                        resetForm={resetForm}
                        min={0}
                        labelText={trans("UnitPrice")}
                        mode={mode}
                        defaultValue={""}
                      /> */}
                      <PriceInput
                         Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        name={"UnitPrice"}
                        resetForm={resetForm}
                        min={0}
                        label={trans("UnitPrice")}
                        mode={mode}
                        defaultValue={""}
                      />
                    </div>
                    <div className="col-auto row align-items-center">
                      <div className="col-auto">
                        <CheckableButton
                          onchange={(e) => e && setIncreaseOrDecrease(0)}
                          defaultChecked={increaseOrDecrease == 0}
                          labelText={"increase"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                        />
                      </div>
                      <div className="col-auto">
                        <CheckableButton
                          // defaultChecked={IsDefault}
                          onchange={(e) => e && setIncreaseOrDecrease(1)}
                          labelText={"decrease"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                          defaultChecked={increaseOrDecrease == 1}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-xxl-2 col-sm-3  me-lg-5 mt-1">
                      <EnumerationTypeSelect
                        mode={mode}
                        type="SelectBox"
                        label="PriceRoundingPlace"
                        name="RoundingPlace"
                        enumTypeSelect="PriceRoundingPlace"
                        value={""}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {priceType == PriceTypeEnum.UnitPercent ? (
                  <div className="row">
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName={"UnitPercent"}
                        textboxType="number"
                        step="any"
                        resetForm={resetForm}
                        labelText={trans("UnitPercent") + " %"}
                        mode={mode}
                        defaultValue={""}
                        min={0}
                        max={increaseOrDecrease==1?99:undefined}
                      />
                    </div>
                    <div className="col-auto row align-items-center">
                      <div className="col-auto">
                        <CheckableButton
                          onchange={(e) => e && setIncreaseOrDecrease(0)}
                          defaultChecked={increaseOrDecrease == 0}
                          labelText={"increase"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                        />
                      </div>
                      <div className="col-auto">
                        <CheckableButton
                          // defaultChecked={IsDefault}
                          onchange={(e) => e && setIncreaseOrDecrease(1)}
                          labelText={"decrease"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                          defaultChecked={increaseOrDecrease == 1}
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-xxl-2 col-sm-3 me-lg-5 mt-1 me-4">
                      <EnumerationTypeSelect
                        mode={mode}
                        type="SelectBox"
                        label="PriceRoundingPlace"
                        name="RoundingPlace"
                        enumTypeSelect="PriceRoundingPlace"
                        value={""}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {priceType == PriceTypeEnum.DiscountPercent ? (
                  <div className="row">
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        min={0}
                        step={'any'}
                        textboxName={"DiscountPercent"}
                        textboxType="number"
                        resetForm={resetForm}
                        labelText={trans("DiscountPercent") + " %"}
                        mode={mode}
                        defaultValue={""}
                        max={100}
                      />
                    </div>
                    <div className="col-auto row align-items-center">
                      <div className="col-auto">
                        <CheckableButton
                          onchange={(e) => e && setIncreaseOrDecrease(0)}
                          defaultChecked={increaseOrDecrease == 0}
                          labelText={"increase"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                        />
                      </div>
                      <div className="col-auto">
                        <CheckableButton
                          // defaultChecked={IsDefault}
                          onchange={(e) => e && setIncreaseOrDecrease(1)}
                          labelText={"decrease"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                          defaultChecked={increaseOrDecrease == 1}
                        />
                      </div>
                        
                    </div>
                  </div>
                ) : (
                  <></>
                )}

           {priceType == PriceTypeEnum.AddedValueDeduction ? (
                  <div className="row">
             
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                      <EnumerationTypeSelect
                        mode={mode}
                        type="SelectBox"
                        label="PriceRoundingPlace"
                        name="RoundingPlace"
                        enumTypeSelect="PriceRoundingPlace"
                        value={""}
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {priceType == PriceTypeEnum.Range ? (
                  <div className="row">
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        required
                        textboxName={"MinOrderQty"}
                        textboxType="number"
                        resetForm={resetForm}
                        labelText={"MinOrderQty"}
                        mode={mode}
                        defaultValue={""}
                        min={0}
                        
                        // usePrevDefaultValue={userChanges.MaxOrderQty==0?null:userChanges.MaxOrderQty}

                        // max={userChanges.MaxOrderQty==0 ||userChanges.MaxOrderQty==null ?undefined:userChanges.MaxOrderQty}
                      />
                    </div>
                    <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                      <Textbox
                        Change={(e) => {
                          setUserChanges({ ...userChanges, ...e });
                        }}
                        textboxName={"MaxOrderQty"}
                        textboxType="text"
                        asNumber
                        resetForm={resetForm}
                        labelText={"MaxOrderQty"}
                        mode={mode}
                        // usePrevDefaultValue={userChanges.MinOrderQty}
                
                      />
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {/* <div className="row">
                  {Price ? (
                    <>
                      <div
                        className="col-md-3 col-sm-12"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <PriceInput
                          onChange={(e) => {
                            if (e?.Id == -1) {
                              setNeedToCall(true);
                            } else {
                              setNeedToCall(false);
                            }
                          }}
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          name={"Price"}
                          resetForm={resetForm}
                          label={"Price"}
                          mode={mode}
                          value={""}
                        />
                      </div>
                      <div
                        className="col-md-3 col-sm-12"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <Textbox
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName={"DiscountPercent"}
                          textboxType="number"
                          resetForm={resetForm}
                          labelText={"DiscountPercent"}
                          mode={mode}
                          defaultValue={""}
                        />
                      </div>
                      {!needToCall && (
                        <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                          <EnumerationTypeSelect
                            mode={mode}
                            type="SelectBox"
                            label="PriceRoundingPlace"
                            name="RoundingPlace"
                            enumTypeSelect="PriceRoundingPlace"
                            value={""}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <div
                        className="col-md-3 col-sm-12"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <Textbox
                          max={100}
                          onChange={(e) => {
                            // if(e.target.value.startsWith('-')){
                            //   setUserChanges({...userChanges,DiscountPercent:'0'})
                            //       } // prevent to enter negetiv number
                            if (+e.target.value > 100) {
                              setUserChanges({
                                ...userChanges,
                                Percent: "100",
                              });
                            }
                          }}
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName={"Percent"}
                          textboxType="number"
                          resetForm={resetForm}
                          labelText={"Percent"}
                          mode={mode}
                          defaultValue={userChanges.Percent}
                        />
                      </div>
                      <div
                        className="col-md-3 col-sm-12"
                        style={{ display: "flex", flexDirection: "row" }}
                      >
                        <Textbox
                          max={100}
                          onChange={(e) => {
                            // if(e.target.value.startsWith('-')){
                            //   setUserChanges({...userChanges,DiscountPercent:'0'})
                            //       } // prevent to enter negetiv number
                            if (+e.target.value > 100) {
                              setUserChanges({
                                ...userChanges,
                                DiscountPercent: "100",
                              });
                            }
                          }}
                          Change={(e) => {
                            setUserChanges({ ...userChanges, ...e });
                          }}
                          textboxName={"DiscountPercent"}
                          textboxType="number"
                          resetForm={resetForm}
                          labelText={"DiscountPercent"}
                          mode={mode}
                          defaultValue={userChanges.DiscountPercent}
                        />
                      </div>
                      <div className="col-lg-2 col-xxl-2 col-sm-3 mt-1">
                        <EnumerationTypeSelect
                          mode={mode}
                          type="SelectBox"
                          label="PriceRoundingPlace"
                          name="RoundingPlace"
                          enumTypeSelect="PriceRoundingPlace"
                          value={""}
                        />
                      </div>
                    </>
                  )}
                </div> */}
              </div>
            </div>
          </>

          {mode != "view" ? (
            <div className="col-lg-12 mt-1 btns_form">
              <Button value="Save" btnType="submit" />
              <Button btnType="cancel" value="Cancel" onClick={onHide} />
            </div>
          ) : (
            <div className="col-lg-12 mt-1 btns_form">
              <Button btnType="primary" value="Close" onClick={onHide} />
            </div>
          )}
        </form>
      </>
    </>
  );
};
